import * as misc from '../actionCreators/miscellaneous';
import * as credential from '../actionCreators/credentials';
import * as credentialApis from '../../services/api/credentials';
import { extractErrorMessage } from '../helpers';
import { getFileToDownload } from '../../utils/Common';

export const doGetCredential = (organisationId, payload, onSuccess, appendData) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    const { data } = await credentialApis.GetCredentialList(organisationId, payload);
    onSuccess && onSuccess(data);
    dispatch(credential.getCredentialList({ data: data.message, appendData }));
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doClearCredential = () => (dispatch) => {
  dispatch(credential.clearCredentialList());
};

export const doAddSingleCredential = (organisationId, payload, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    await credentialApis.AddSingleCredential(organisationId, payload);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(
      misc.doCreateNotification({
        isVisible: true,
        message: 'Credential created Successfully',
      }),
    );
    callBack('success');
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doAddBulkCredentials = (orgId, payload, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    dispatch(credential.setBulkAddDetails({
      total: 0,
      requestId: '',
      processed: 0,
      render: 0,
      failed: 0,
      success: 0,
      type: 0,
      show: false,
      orgId: 0,
    }))
    const { data } = await credentialApis.AddBulkCredentials(orgId, payload);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(credential.setBulkAddDetails({
      total: payload?.credentials?.length || 0,
      requestId: data?.message?.requestId,
      show: true,
      orgId: payload?.orgId
    }))
    callBack('success');
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doRequestBulkStatus = (organisationId, partnerId, requestId, callBack) => async (dispatch) => {
  try {
    const { data } = await credentialApis.GetBulkRequestStatus(organisationId, partnerId, requestId);
    dispatch(credential.setBulkAddDetails({
      total: data?.message?.total || 0,
      processed: data?.message?.processed || 0,
      success: data?.message?.success || 0,
      failed: data?.message?.failed || 0,
      type: data?.message?.total === data?.message?.processed ? data?.message?.failed ? 2 : 1 : 0
    }))
    callBack(data);
  } catch (error) {
    console.log({ error })
  }
};

export const doDeleteCredential = (organisationId, payload, onSuccess) => async (dispatch) => {
  try {
    await credentialApis.DeleteCredentials(organisationId, payload);
    onSuccess && onSuccess()
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doDownloadCredential = (organisationId, payload, orgName) => async (dispatch) => {
  try {
    const res = await credentialApis.CredentialReportDownload(organisationId, payload);
    getFileToDownload(res, `Credential List - ${orgName}.xlsx`)
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};
